import { V3Record } from 'data/helpers/V3Record.js'

export const Region = V3Record('region', {
  name: null
})
